"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryToContinentMap = exports.countryNameList = exports.isoCountryCodeList = exports.isoCountryMap = void 0;
exports.isoCountryMap = {
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua And Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BA: 'Bosnia And Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic',
    CK: 'Cook Islands',
    CR: 'Costa Rica',
    CI: "Cote D'Ivoire",
    HR: 'Croatia',
    CU: 'Cuba',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (Malvinas)',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island & Mcdonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran, Islamic Republic Of',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle Of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libyan Arab Jamahiriya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia, Federated States Of',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    AN: 'Netherlands Antilles',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestinian Territory, Occupied',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent And Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome And Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia And Sandwich Isl.',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard And Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad And Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks And Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    US: 'United States',
    UM: 'United States Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'Virgin Islands, British',
    VI: 'Virgin Islands, U.S.',
    WF: 'Wallis And Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
};
exports.isoCountryCodeList = Object.keys(exports.isoCountryMap);
exports.countryNameList = Object.values(exports.isoCountryMap);
var validContinentValues = ['Middle East and Africa', 'Asia', 'Europe', 'North and Central America', 'Oceania', 'South America', 'Antarctica'];
exports.countryToContinentMap = {
    AF: 'Asia',
    AX: 'Europe',
    AL: 'Europe',
    DZ: 'Middle East and Africa',
    AS: 'Oceania',
    AD: 'Europe',
    AO: 'Middle East and Africa',
    AI: 'North and Central America',
    AQ: 'Antarctica',
    AG: 'North and Central America',
    AR: 'South America',
    AM: 'Asia',
    AW: 'North and Central America',
    AU: 'Oceania',
    AT: 'Europe',
    AZ: 'Asia',
    BS: 'North and Central America',
    BH: 'Middle East and Africa',
    BD: 'Asia',
    BB: 'North and Central America',
    BY: 'Europe',
    BE: 'Europe',
    BZ: 'North and Central America',
    BJ: 'Middle East and Africa',
    BM: 'North and Central America',
    BT: 'Asia',
    BO: 'South America',
    BA: 'Europe',
    BW: 'Middle East and Africa',
    BV: 'Antarctica',
    BR: 'South America',
    IO: 'Asia',
    BN: 'Asia',
    BG: 'Europe',
    BF: 'Middle East and Africa',
    BI: 'Middle East and Africa',
    KH: 'Asia',
    CM: 'Middle East and Africa',
    CA: 'North and Central America',
    CV: 'Middle East and Africa',
    KY: 'North and Central America',
    CF: 'Middle East and Africa',
    TD: 'Middle East and Africa',
    CL: 'South America',
    CN: 'Asia',
    CX: 'Asia',
    CC: 'Asia',
    CO: 'South America',
    KM: 'Middle East and Africa',
    CG: 'Middle East and Africa',
    CD: 'Middle East and Africa',
    CK: 'Oceania',
    CR: 'North and Central America',
    CI: 'Middle East and Africa',
    HR: 'Europe',
    CU: 'North and Central America',
    CY: 'Asia',
    CZ: 'Europe',
    DK: 'Europe',
    DJ: 'Middle East and Africa',
    DM: 'North and Central America',
    DO: 'North and Central America',
    EC: 'South America',
    EG: 'Middle East and Africa',
    SV: 'North and Central America',
    GQ: 'Middle East and Africa',
    ER: 'Middle East and Africa',
    EE: 'Europe',
    ET: 'Middle East and Africa',
    FK: 'South America',
    FO: 'Europe',
    FJ: 'Oceania',
    FI: 'Europe',
    FR: 'Europe',
    GF: 'South America',
    PF: 'Oceania',
    TF: 'Antarctica',
    GA: 'Middle East and Africa',
    GM: 'Middle East and Africa',
    GE: 'Asia',
    DE: 'Europe',
    GH: 'Middle East and Africa',
    GI: 'Europe',
    GR: 'Europe',
    GL: 'North and Central America',
    GD: 'North and Central America',
    GP: 'North and Central America',
    GU: 'Oceania',
    GT: 'North and Central America',
    GG: 'Europe',
    GN: 'Middle East and Africa',
    GW: 'Middle East and Africa',
    GY: 'South America',
    HT: 'North and Central America',
    HM: 'Antarctica',
    VA: 'Europe',
    HN: 'North and Central America',
    HK: 'Asia',
    HU: 'Europe',
    IS: 'Europe',
    IN: 'Asia',
    ID: 'Asia',
    IR: 'Middle East and Africa',
    IQ: 'Middle East and Africa',
    IE: 'Europe',
    IM: 'Europe',
    IL: 'Middle East and Africa',
    IT: 'Europe',
    JM: 'North and Central America',
    JP: 'Asia',
    JE: 'Europe',
    JO: 'Middle East and Africa',
    KZ: 'Asia',
    KE: 'Middle East and Africa',
    KI: 'Oceania',
    KR: 'Asia',
    KW: 'Middle East and Africa',
    KG: 'Asia',
    LA: 'Asia',
    LV: 'Europe',
    LB: 'Middle East and Africa',
    LS: 'Middle East and Africa',
    LR: 'Middle East and Africa',
    LY: 'Middle East and Africa',
    LI: 'Europe',
    LT: 'Europe',
    LU: 'Europe',
    MO: 'Asia',
    MK: 'Europe',
    MG: 'Middle East and Africa',
    MW: 'Middle East and Africa',
    MY: 'Asia',
    MV: 'Asia',
    ML: 'Middle East and Africa',
    MT: 'Europe',
    MH: 'Oceania',
    MQ: 'North and Central America',
    MR: 'Middle East and Africa',
    MU: 'Middle East and Africa',
    YT: 'Middle East and Africa',
    MX: 'North and Central America',
    FM: 'Oceania',
    MD: 'Europe',
    MC: 'Europe',
    MN: 'Asia',
    ME: 'Europe',
    MS: 'North and Central America',
    MA: 'Middle East and Africa',
    MZ: 'Middle East and Africa',
    MM: 'Asia',
    NA: 'Middle East and Africa',
    NR: 'Oceania',
    NP: 'Asia',
    NL: 'Europe',
    AN: 'North and Central America',
    NC: 'Oceania',
    NZ: 'Oceania',
    NI: 'North and Central America',
    NE: 'Middle East and Africa',
    NG: 'Middle East and Africa',
    NU: 'Oceania',
    NF: 'Oceania',
    MP: 'Oceania',
    NO: 'Europe',
    OM: 'Middle East and Africa',
    PK: 'Asia',
    PW: 'Oceania',
    PS: 'Asia',
    PA: 'North and Central America',
    PG: 'Oceania',
    PY: 'South America',
    PE: 'South America',
    PH: 'Asia',
    PN: 'Oceania',
    PL: 'Europe',
    PT: 'Europe',
    PR: 'North and Central America',
    QA: 'Middle East and Africa',
    RE: 'Middle East and Africa',
    RO: 'Europe',
    RU: 'Europe',
    RW: 'Middle East and Africa',
    BL: 'North and Central America',
    SH: 'Middle East and Africa',
    KN: 'North and Central America',
    LC: 'North and Central America',
    MF: 'North and Central America',
    PM: 'North and Central America',
    VC: 'North and Central America',
    WS: 'Oceania',
    SM: 'Europe',
    ST: 'Middle East and Africa',
    SA: 'Middle East and Africa',
    SN: 'Middle East and Africa',
    RS: 'Europe',
    SC: 'Middle East and Africa',
    SL: 'Middle East and Africa',
    SG: 'Asia',
    SK: 'Europe',
    SI: 'Europe',
    SB: 'Oceania',
    SO: 'Middle East and Africa',
    ZA: 'Middle East and Africa',
    GS: 'Antarctica',
    ES: 'Europe',
    LK: 'Asia',
    SD: 'Middle East and Africa',
    SR: 'South America',
    SJ: 'Europe',
    SZ: 'Middle East and Africa',
    SE: 'Europe',
    CH: 'Europe',
    SY: 'Asia',
    TW: 'Asia',
    TJ: 'Asia',
    TZ: 'Middle East and Africa',
    TH: 'Asia',
    TL: 'Oceania',
    TG: 'Middle East and Africa',
    TK: 'Oceania',
    TO: 'Oceania',
    TT: 'North and Central America',
    TN: 'Middle East and Africa',
    TR: 'Middle East and Africa',
    TM: 'Asia',
    TC: 'North and Central America',
    TV: 'Oceania',
    UG: 'Middle East and Africa',
    UA: 'Europe',
    AE: 'Middle East and Africa',
    GB: 'Europe',
    US: 'North and Central America',
    UM: 'Oceania',
    UY: 'South America',
    UZ: 'Asia',
    VU: 'Oceania',
    VE: 'South America',
    VN: 'Asia',
    VG: 'North and Central America',
    VI: 'North and Central America',
    WF: 'Oceania',
    EH: 'Middle East and Africa',
    YE: 'Middle East and Africa',
    ZM: 'Middle East and Africa',
    ZW: 'Middle East and Africa',
};
//# sourceMappingURL=CountriesList.js.map